import { makeStyles } from "@material-ui/core/styles";
import { Box, Divider, List } from "@material-ui/core";
import thunderRedImg from "../../../images/contents/map/liden/thunder_red.png";
import thunderOrangeImg from "../../../images/contents/map/liden/thunder_orange.png";
import thunderYellowImg from "../../../images/contents/map/liden/thunder_yellow.png";
import thunderYellowGreenImg from "../../../images/contents/map/liden/thunder_yellow_green.png";
import thunderLightBlueImg from "../../../images/contents/map/liden/thunder_light_blue.png";
import thunderBlueImg from "../../../images/contents/map/liden/thunder_blue.png";
import { useTranslation } from "react-i18next";
import { LegendCssIcoListItem, LegendBoxListItem, LegendBoxListItemText, LegendBoxContentsName } from "../../legend/LegendBoxComponents";
import { memo } from "react";

const useStyles = makeStyles(_ => ({
  icon: {
    verticalAlign: "middle",
    height: "16px"
  },
  divider: {
    height: 2,
    backgroundColor: "rgba(0, 0, 0, 0.22)"
  }
}));

function LegendLightning() {
  const classes = useStyles();
  const {t} = useTranslation();

  return (
    <Box sx={{minWidth: 205}}>
      <Box>
        <LegendBoxContentsName>{t('LIDEN')}</LegendBoxContentsName>
        <List>
          <LegendBoxListItem><img src={thunderRedImg} alt="less than or equal 10 min" className={classes.icon}/><LegendBoxListItemText>〜10</LegendBoxListItemText></LegendBoxListItem>
          <LegendBoxListItem><img src={thunderOrangeImg} alt="less than or equal 20 min" className={classes.icon}/><LegendBoxListItemText>〜20</LegendBoxListItemText></LegendBoxListItem>
          <LegendBoxListItem><img src={thunderYellowImg} alt="less than or equal 30 min" className={classes.icon}/><LegendBoxListItemText>〜30</LegendBoxListItemText></LegendBoxListItem>
          <LegendBoxListItem><img src={thunderYellowGreenImg} alt="less than or equal 40 min" className={classes.icon}/><LegendBoxListItemText>〜40</LegendBoxListItemText></LegendBoxListItem>
          <LegendBoxListItem><img src={thunderLightBlueImg} alt="less than or equal 50 min" className={classes.icon}/><LegendBoxListItemText>〜50</LegendBoxListItemText></LegendBoxListItem>
          <LegendBoxListItem><img src={thunderBlueImg} alt="less than or equal 60 min" className={classes.icon}/><LegendBoxListItemText>〜60 (min)</LegendBoxListItemText></LegendBoxListItem>
        </List>
      </Box>
      <Divider className={classes.divider}></Divider>
      <Box>
        <LegendBoxContentsName>{t('Nowcast')}</LegendBoxContentsName>
        <List>
          <LegendCssIcoListItem background={"rgb(128, 0, 128)"} text={t("Severe TS")}></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(255, 0, 0)"} text={t("Moderate TS")}></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(255, 165, 0)"} text={t("Distant TS")}></LegendCssIcoListItem>
          <LegendCssIcoListItem background={"rgb(255, 255, 0)"} text={t("Possible CB")}></LegendCssIcoListItem>
        </List>
      </Box>
    </Box>
  )
}

export default memo(LegendLightning);